import { useRef, useCallback, useEffect } from 'react';

const useOutsideScroll = (element, onOutsideScroll, autoCloseOnScroll = false) => {
    const isCursorOverElement = useRef(false);
    const handleOutsideScroll = useCallback((event) => {
        if (isCursorOverElement.current)
            return;
        onOutsideScroll(event);
    }, [onOutsideScroll]);
    useEffect(() => {
        if (!autoCloseOnScroll || !element)
            return;
        if (element && autoCloseOnScroll) {
            const handleMouseEnter = () => {
                isCursorOverElement.current = true;
            };
            const handleMouseLeave = () => {
                isCursorOverElement.current = false;
            };
            window.addEventListener('scroll', handleOutsideScroll, true);
            element.addEventListener('mouseenter', handleMouseEnter);
            element.addEventListener('mouseleave', handleMouseLeave);
            return () => {
                window.removeEventListener('scroll', handleOutsideScroll, false);
                if (element) {
                    element.removeEventListener('mouseenter', handleMouseEnter);
                    // eslint-disable-next-line react-hooks/exhaustive-deps
                    element.removeEventListener('mouseleave', handleMouseLeave);
                }
            };
        }
    }, [element, handleOutsideScroll, autoCloseOnScroll]);
    return isCursorOverElement;
};

export { useOutsideScroll };
